/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useContext } from 'react'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { strCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import { getWsBreakerData, importWsBreakerData } from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUnits,
} from 'core'
import { Button, DatePicker, Select, message } from 'antd'
import { ErrorContext } from 'context'
import CommonScreen from 'admin/component/CommonScreen'
import moment from 'moment'

const title = 'Breaker Data'

const WsBreakerDataHeaders = [
  strCol({
    ident: 'unitid',
    display: 'Unit',
    width: 350,
    isKey: true,
    sortOrder: 'asc',
    isFiltered: true,
    ellipsis: true,
  }),
  dateTimeCol({
    ident: 'transdate',
    display: 'Time (Local Zone in PST)',
    isKey: true,
    sortOrder: 'desc',
    isFiltered: true,
    width: 150,
  }),
  strCol({
    ident: 'status',
    display: 'Status',
    isFiltered: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'processed',
    display: 'PROCESSED',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const WsBreakerData = ({
  targetInfo,
  // envConfig,
  // actionPermits,
  unitNameMap,
}) => {
  const [date, setDate] = useState(moment().subtract(1, 'month'))
  const [zone, setZone] = useState('Local Zone')
  const [importing, setImporting] = useState(false)
  const { setError } = useContext(ErrorContext)

  const withCriteria = (state, props, selectedUnits) => {
    return {
      start: moment(date).startOf('month'),
      end: moment(date).endOf('month'),
      units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
      zone,
    }
  }

  const headerWithFormatter = WsBreakerDataHeaders.map(header =>
    header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => unitNameMap[value] || value,

          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitid] || rowData.unitid,
        }
      : header
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <>
        <DatePicker.MonthPicker
          style={{ marginLeft: '15px' }}
          allowClear={false}
          format="MMM YYYY"
          value={date}
          onChange={d => {
            setDate(d)
            onChange()
          }}
        />
        <Select
          allowClear
          value={zone}
          style={{ width: '150px', marginLeft: '10px' }}
          onChange={value => setZone(value)}
        >
          <Select.Option key="Local Zone">Local Zone</Select.Option>
        </Select>
      </>
    )
  }

  const extraCriteriaAfterButton = ({ selectedUnits }) => {
    return (
      <Button
        loading={importing}
        onClick={() => {
          const req = {
            start: date.startOf('month'),
            end: date.endOf('month'),
            units: (selectedUnits || []).filter(e => !!e).map(e => e.unitId),
          }
          setImporting(true)
          importWsBreakerData(targetInfo)(req).fork(setError, () => {
            message.info(
              'Data started importing, Please check data after sometime.'
            )
            setImporting(false)
          })
        }}
        style={{ marginLeft: '10px' }}
        type="danger"
        icon="thunderbolt"
      >
        Import Data
      </Button>
    )
  }

  return (
    <CommonScreen
      withUnitSelection
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withoutModify
      allowInsert={false}
      isEditableGrid={_ => false}
      autoRetrieve={false}
      isAdminScreen
      withCriteria={withCriteria}
      title={title}
      header={headerWithFormatter}
      retrieveTask={getWsBreakerData}
      altBy={u => u.unitid}
      sortOptions={WsBreakerDataHeaders}
      initialSortOptions={WsBreakerDataHeaders}
      widthOffset={50}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(WsBreakerData)
